var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderSaleInvoicetax',{attrs:{"img_header":_vm.header_image,"header":"แก้ไขใบแจ้งหนี้/ใบกำกับภาษี (Modify invoice/tax invoice)","link_back":"salemain/saleinvoicetaxwholesale"}}),_c('Edit_invoice_wholesale')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }